// extracted by mini-css-extract-plugin
module.exports = {"wrap":"style_wrap__3fcPN","title":"style_title__sZfEQ","imageWrap":"style_imageWrap__1PSP5","content":"style_content__1Sjsf","footer":"style_footer__11Fz2"};